import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const BadgesWrapper = styled(Flex)`
  position: absolute;
  z-index: 1;
`;
